import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageSectionComponent } from './page-section.component';

@NgModule({
    declarations: [PageSectionComponent],
    imports: [
        CommonModule
    ],
    exports: [
        PageSectionComponent
    ]
})
export class PageSectionModule { }
